import { PulserLoading, brand } from '@arnold/common';
import { ReactComponent as ArnoldLoading } from '../assets/images/ArnoldLoading.svg';

export const LoadingAnimation = () => (brand === 'pulser' ? <PulserLoading /> : <ArnoldLoading />);
